export const MAP_DECORATION_CONFIG = {
  // Density multiplier for general decorations
  density: 1.0,

  // Number of ruin clusters per module
  ruinClusterCount: 1,

  // Number of stone clusters per module
  stoneClusterCount: 2,

  // Number of flower patches / moss patches per module
  flowerPatchCount: 3,

  // Number of glowing details (mushrooms, fireflies, energy marks) per module
  glowingDetailCount: 4,

  // Density of details placed specifically on the dirt/stone path (0 = none, 1 = high)
  pathDetailDensity: 0.42,

  // Depth mode for decorations: 'ySorted' (tall objects sorted by Y in actors layer) or 'layers' (static background layer)
  decorationDepthMode: "ySorted",

  // Whether decorative items can sometimes have collision enabled
  collisionDecorationEnabled: false
} as const;
